



import {Component, Vue} from 'vue-property-decorator';

const MilestoneStage = () => import('@/components/Templates/MilestoneStage/MilestoneStage.vue')
const HorizontalCordGroup = () => import('@/components/Molecules/HorizontalCordGroup/HorizontalCordGroup.vue')
const TreeModalCardInfo = () => import('@/components/Organisms/TreeModalCardInfo/TreeModalCardInfo.vue')

import {GROW_TREE_TYPE} from "@/constants";
import {eventBusService, ServiceFactory} from "@/services";
import {BabyFilter, EventBusTreeModalType, MilestoneDetailModel} from "@/share";
import PinchScrollZoom, {PinchScrollZoomEmitData} from "@coddicat/vue-pinch-scroll-zoom";

const CategoryService = ServiceFactory.get('category');
const MilestoneService = ServiceFactory.get('milestone');

@Component({
  components: {MilestoneStage, HorizontalCordGroup, TreeModalCardInfo, PinchScrollZoom}
})
export default class GrowTree extends Vue {
  private isLoading = false
  private data = []
  private dataModal = {}
  private modalVisible = false
  private babyId = this.$route.params.id
  private isFocus = true
  private isPinchScrollZoom = false
  private scale = 1
  private width = 412
  private height = 857
  private contentWidth = 6560
  private contentHeight = 2560
  private minScale = this.height / this.contentHeight
  private maxScale = 1
  private translateX = 0
  private translateY = 0
  private transformOriginX = 0
  private transformOriginY = 0

  private created() {
    this.getGrowTreeData()
    eventBusService.$on(
      eventBusService.EVENT_SHOW_TREE_MODAL,
      (data: EventBusTreeModalType) => this.showModal(data)
    )
  }

  private mounted() {
    this.initZoom()
  }

  private async getGrowTreeData(): Promise<void> {
    const params: BabyFilter = new BabyFilter({
      babyId: this.babyId
    })

    this.isLoading = true
    const data = await CategoryService.growTree(params).catch(() => [])
    this.isLoading = false

    this.data = data
  }

  private get horizontalCordTotal(): any {
    return (type: number) => {
      if (type == GROW_TREE_TYPE.INTERACTION) return 14
      if (type == GROW_TREE_TYPE.WC) return 8
      return 5
    }
  }

  private initZoom() {
    const el: any = this.$refs.content
    this.width = el.offsetWidth
    this.height = el.offsetHeight
    this.minScale = this.height / this.contentHeight
    this.isPinchScrollZoom = true
  }

  private pinchScrollZoomHandler(e: PinchScrollZoomEmitData): void {
    this.scale = e.scale
    this.translateY = e.y
    this.translateX = e.x
    this.transformOriginX = e.originX
    this.transformOriginY = e.originY
  }

  private async showModal(data: any): Promise<void> {
    const zoomer = (this.$refs.zoomer as PinchScrollZoom)
    if (!zoomer) return

    this.isFocus = true
    let y = this.translateY
    const pageY = data.pageY
    if (pageY && pageY > 140) {
      y = y - pageY + 140
      this.translateY = y
    }

    const pageX = data.pageX
    const screenWidth: any = window.screen.width
    const clientX = pageX - (screenWidth / 2 - this.width / 2)
    let x = this.translateX

    if ((clientX > this.width - 80) || clientX < 80) {
      x = x + screenWidth/2 - pageX
      this.translateX = x
    }

    zoomer.setData({
      scale: this.scale,
      originX: this.transformOriginX,
      originY: this.transformOriginY,
      translateX: x,
      translateY: y
    });

    const milestoneId = data.id
    const params: BabyFilter = new BabyFilter({
      babyId: this.babyId
    })
    this.dataModal = await MilestoneService.show(milestoneId, params).catch(() => new MilestoneDetailModel({}))
    this.modalVisible = true
  }

  private handlerHiddenModal(): void {
    this.modalVisible = false
    this.isFocus = false
  }
}
